import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import ScrollToTop from "./layouts/ScrollToTop";
import Footer from "./layouts/Footer";

/// Pages
import Registration from "./pages/Registration";
import Login from "./pages/Login";



/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Doctors from "./components/Dashboard/Doctors";

import DoctorsReview from "./components/Dashboard/Doctors-Review";
import PatientDetails from "./components/Dashboard/Patient-Details";
import FlatIcon from "./components/Dashboard/FlatIcon.js";

// CMS
import Content from './components/Cms/Content';
import Menu from './components/Cms/Menu';
import EmailTemplate from './components/Cms/EmailTemplate';
import Blog from './components/Cms/Blog';
import ContentAdd from './components/Cms/ContentAdd';
import AddMail from './components/Cms/AddMail';
import AddBlog from './components/Cms/AddBlog';
import BlogCategory from './components/Cms/BlogCategory';
import Treatments from './components/Cms/Treatments';
import Executivemembers from './components/Cms/executivemembers';
import Constitution from './components/Cms/Constitution';
import TrainingCenters from './components/Cms/TrainingCenter';
import Fellowship from './components/Cms/Fellowship';
import DoctorDetails from './components/Cms/Doctor';
import Awards from './components/Cms/Awards';
import TravelGrant from './components/Cms/TravelGrant';
import JuniorWing from './components/Cms/JuniorWing';
import Membership from './components/table/Membership';
// Bootstrap

import BootstrapTable from "./components/table/BootstrapTable";

/// Forms
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";

import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

import { ThemeContext } from "../context/ThemeContext";

/// 🔥 PRIVATE ROUTE
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/page-login" />;
};

const Markup = () => {
  const allroutes = [
    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "index-2", component: <DashboardDark /> },
    { url: "doctors-review", component: <DoctorsReview /> },
    { url: "patient-details", component: <PatientDetails /> },
    { url: "flat-icons", component: <FlatIcon /> },

    { url: 'blogs', component: <Content /> },
    { url: 'menu', component: <Menu /> },
    { url: 'email-template', component: <EmailTemplate /> },
    { url: 'blog', component: <Blog /> },
    { url: 'add-content', component: <ContentAdd /> },
    { url: 'events', component: <AddMail /> },
    { url: 'add-blog', component: <AddBlog /> },
    { url: 'blog-category', component: <BlogCategory /> },
    { url: 'treatments', component: <Treatments /> },
    { url: 'executivemembers', component: <Executivemembers /> },
    { url: "appointments", component: <BootstrapTable /> },
    { url: "testimonials", component: <Element /> },
    { url: "faq", component: <Wizard /> },
    { url: "gallery", component: <Lightgallery /> },
    { url: "constitution", component: <Constitution /> },
    { url: "trainingcenters", component: <TrainingCenters /> },
    { url: "fellowship", component: <Fellowship /> },
    { url: "doctors", component: <DoctorDetails /> },
    { url: "awards", component: <Awards /> },
    { url: "international-travel-grant", component: <TravelGrant /> },
    { url: "junior-wing", component: <JuniorWing /> },
    { url: "membership", component: <Membership /> }


  ];

  return (
    <>
      <Routes>

        {/* PUBLIC ROUTES */}
        <Route path='page-login' element={<Login />} />
        <Route path='page-register' element={<Registration />} />

        {/* DEFAULT REDIRECT */}
        <Route path="/" element={<Navigate to="/page-login" />} />

        {/* 🔥 PROTECTED ROUTES */}
        <Route
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              path={data.url}
              element={data.component}
            />
          ))}
        </Route>

      </Routes>

      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector(state => state.sideMenu);

  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "icon-hover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}
    >
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 60 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Markup;